import * as mutations from './types/mutations';
import { audioBookMapper } from './normalizer';

export default {
    [mutations.SET_AUDIO_BOOK]: (state, audioBook) => {
        state.audioBook = audioBookMapper(audioBook);
    }
};
